"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flattenCartContent;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var flattenSubject = function flattenSubject(subject) {
  var ind = subject.indirectSubjects || [];
  var ns = (0, _extends2.default)({}, subject, {
    indirectSubjects: undefined
  });
  return [ns].concat((0, _toConsumableArray2.default)(ind));
};

var flattenSubjectArr = function flattenSubjectArr(subjects) {
  return subjects.map(flattenSubject).reduce(function (a, s) {
    return [].concat((0, _toConsumableArray2.default)(a), (0, _toConsumableArray2.default)(s));
  }, []);
};

function flattenCartContent(cart) {
  return [].concat((0, _toConsumableArray2.default)(flattenSubjectArr(cart.subjects)), (0, _toConsumableArray2.default)(flattenSubject(cart.payment)), (0, _toConsumableArray2.default)(flattenSubject(cart.shipping)), (0, _toConsumableArray2.default)(cart.indirectSubjects || []));
}